module.exports = __webpack_public_path__ + "static/media/specific-follower.2c02817d.svg";